import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

import main4049Webp from '@/assets/landing-age-selection/main-40-49.webp'
import age5059Img from '@/assets/landing/chair-yoga-gs-adapted/age-50.png'
import age6069Img from '@/assets/landing/chair-yoga-gs-adapted/age-60.png'
import age7080Img from '@/assets/landing/chair-yoga-gs-adapted/age-70.png'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'CHAIR YOGA FOR<br/>BEGINNERS',
					size: 'large',
					uppercase: true,
				}),
				LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
					theme: 'blue',
					ageRanges: [
						{
							value: 40,
							analyticValue: '40-49',
							label: $t('female_yoga.pages.landing.age_range.40_49'),
							img: main4049Webp,
						},
						{
							value: 50,
							analyticValue: '50-59',
							label: $t('female_yoga.pages.landing.age_range.50_59'),
							img: age5059Img,
						},
						{
							value: 60,
							analyticValue: '60-69',
							label: $t('female_yoga.pages.landing.age_range.60_69'),
							img: age6069Img,
						},
						{
							value: 70,
							analyticValue: '70+',
							label: $t('female_yoga.pages.landing.age_range.70_80'),
							img: age7080Img,
						},
					],
					otherAgesButton: {
						data: { value: 18, analyticValue: '18-39' },
						text: $t('female_yoga.pages.landing.im_young'),
					},
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
